// extracted by mini-css-extract-plugin
export default {"textCenter":"CheckerPage__textCenter-czcE"};